import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Rx';
import { SegmentEvents }from '../../constants/SegmentEvents';
import { MapsAddStuffService } from '../../maps-add-stuff.service';

@Component({
  selector: 'app-add-retailer',
  templateUrl: './add-retailer.component.html',
  styleUrls: ['./add-retailer.component.less']
})
export class AddRetailerComponent implements OnInit {

  addRetailerInfoWindow : any;
  addRetailerAutocompleteInfoWindow : any;
  mapClickListener: any;
  zoomListener: any;
  addRetailerlatLng: any;
  isSaving: boolean = false;
  currentInstruction: string = '';
  editMode: boolean = false;
  currentRetailer: any;
  focusedSearchItemIndex: number = 0;
  searchPredictions: any = [];
  isLogoFileLoaded: boolean = false;
  logoImageFile: any;
  addRetailerFlowSubscription: Subscription;

  //Events Subscriptions
  closeAddRetailerFlowSubscription: any;
  editRetailerSubscription: any;
  moveRetailerSubscription: any;
  removeRetailerSubscription: any;
  alterRetailerCapsulePublicSubscription: any;

  constructor(public mapsAddStuffService: MapsAddStuffService) { }

  ngOnInit() {
    this.addSubscriptions();
  }

  addSubscriptions() {
    let w = (<any>window);
    this.addRetailerFlowSubscription = this.mapsAddStuffService.addRetailerFlowActiveStream.subscribe((start)=> {
      if(start) {
        this.beginAddRetailerFlow();
      }
    });

    this.closeAddRetailerFlowSubscription = w.Events.subscribe('closeAddRetailerFlow', (value)=>{
      this.closeAddRetailerFlow();
    });
  }

  ngAfterViewInit() {
    let w = (<any>window);
    this.editRetailerSubscription = w.Events.subscribe('editRetailer',(data)=>{
      this.editMode = true;
      this.addRetailerlatLng = data.geom;
      this.currentRetailer = data;
      this.addRetailer(data);
    });

    this.moveRetailerSubscription = w.Events.subscribe('moveRetailer',(data)=>{
      w.Events.publish('startLoadingGrey');
      w.apiProperty.updatePropertyIfRetailerIsChanged(data);
      this.mapsAddStuffService.editRetailer(data).subscribe((response: any)=> {

        w.Events.publish('trackPropertyIds', response.propertyId);
        w.apiProperty.updatePropertyIfRetailerIsChanged(response);
        w.apiRetailer.delete(parseInt(data.retailerId), parseInt(data.locationId));
        w.apiRetailer.addNewRetailer(response);
        w.toggleRetailerFilter([response], true);
        w.Events.publish('segment', {
          name: SegmentEvents.mapRetailerMoved,
          data: {
            retailer_id: response.retailerId,
            location_id: response.locationId,
          }
        });
        w.Events.publish('endLoadingGrey');
        this.closeAddRetailerFlow();
      },(error)=>{
        w.Events.publish('endLoadingGrey');
        let retailer = w.apiRetailer.getSingleRetailer(parseInt(data.retailerId), parseInt(data.locationId));
        retailer.setPosition(retailer.originalPosition);
        if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
          w.Events.publish('usageLimitErrorFeature','move-retailer');
          w.Events.publish('updateFeatureExecutionAfterSignUp', {
            featureToExecute : 'move-retailer',
            requestObject : data
          });
        }
        w.Events.publish('error', error);
      });
    });

    this.removeRetailerSubscription = w.Events.subscribe('removeRetailer',(data)=>{
      this.mapsAddStuffService.deleteRetailer(data.locationId, data.ownerProfileId).subscribe((response: any)=>{
        //As per PC-2183, Deleting retailer by default applied to master map
        if(!response.canAvoidMoveToMasterMap) {
          w.Events.publish('trackPropertyIds', response.propertyId);
        }
        w.contextualInfoWindow.closeAllInfoWindows();
        w.apiProperty.updatePropertyIfRetailerIsChanged(w.apiRetailer.getSingleRetailer(data.retailerId, data.locationId));
        w.apiRetailer.delete(data.retailerId, data.locationId);
        w.leaderLines.showLeaderLines();
        w.Events.publish('segment', {
          name: SegmentEvents.mapRetailerRemoved,
          data: {
            retailer_id: response.retailerId,
            location_id: response.locationId,
          }
        });
        this.closeAddRetailerFlow();
      },(error)=>{
        if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
          w.Events.publish('usageLimitErrorFeature','remove-retailer');
          w.Events.publish('updateFeatureExecutionAfterSignUp', {
            featureToExecute : 'remove-retailer',
            requestObject : data
          });
        }
        w.Events.publish('error', error);
      });
    });

    this.alterRetailerCapsulePublicSubscription = w.Events.subscribe('alterRetailerCapsulePublic',(data)=>{
      w.Events.publish('startLoadingGrey');
      this.mapsAddStuffService.editRetailer(data).subscribe((response: any)=> {
        w.Events.publish('trackPropertyIds', response.propertyId);
        let retailer = w.apiRetailer.getSingleRetailer(response.retailerId, response.locationId);
            retailer.capsuleVersionApprovedForPublicView = response.capsuleVersionApprovedForPublicView;
            retailer.infoWindow = w.contextualInfoWindow.addRetailerInfoWindow(retailer);
            w.Events.publish('endLoadingGrey');
      },(error)=>{
        w.Events.publish('endLoadingGrey');
        w.Events.publish('error', error);
      });
    });
  }

  beginAddRetailerFlow() {
    let w = (<any>window);
    // switch activeRetailersOnRooftop to all to show all retailers
    w.Events.publish('toggleRooftopRetailerSelection', 'all');
    
    w.contextualInfoWindow.closeAllInfoWindows();
    w.addClass(w.domBody, 'add-retailer');
    if(w.map.getZoom() < 18) {
      this.currentInstruction = 'Zoom to retailer location on map.';
      w.map.setOptions({ draggableCursor:'zoom-in' });
    } else {
      this.currentInstruction = 'Pick the retailer location on the map.';
      w.map.setOptions({ draggableCursor:'crosshair' });
    }
    (<any>window).Events.publish('detectChanges');

    this.mapClickListener = w.google.maps.event.addListener(w.map,'click',(e)=>{
      if(w.map.getZoom() < 18) {
        w.map.setCenter(e.latLng);
        w.map.setZoom(18);
        w.map.setOptions({ draggableCursor: 'crosshair' });
        this.currentInstruction = 'Pick the retailer location on the map.';
          (<any>window).Events.publish('detectChanges');
      } else {
        if(!this.addRetailerInfoWindow) {
          this.addRetailerlatLng = e.latLng;
          this.addRetailer();
          w.map.setOptions({ draggableCursor: '' });
        }
      }
    });

    this.zoomListener = w.google.maps.event.addListener(w.map,'zoom_changed',()=>{
      if(w.map.getZoom() < 18) {
        w.map.setZoom(18);
      }
    });
  }

  cancelButtonListener() {
    document.getElementById('btn-cancel-retailer').addEventListener('click',(e:any)=> {
      this.closeAddRetailerFlow();
    });
  }

  closeAddRetailerFlow() {
    let w = (<any>window);
    if(w.map) {
      this.logoImageFile = null;
      this.editMode = false;
      this.isLogoFileLoaded = false;
      w.map.setOptions({ draggableCursor: '' });
      w.removeClass(w.domBody, 'add-retailer');
      w.google.maps.event.removeListener(this.mapClickListener);
      w.google.maps.event.removeListener(this.zoomListener);
      if(this.addRetailerInfoWindow) {
        this.addRetailerInfoWindow.close();
        delete this.addRetailerInfoWindow;
      }
      if(this.addRetailerAutocompleteInfoWindow) {
        this.addRetailerAutocompleteInfoWindow.close();
        delete this.addRetailerAutocompleteInfoWindow;
      }
      this.mapsAddStuffService.addRetailerFlowActiveSource.next(false);
    }
  }

  saveButtonListener(retailerId?, locationId?) {
    let w = (<any>window),
        saveButton = document.getElementById('btn-save-retailer');
    saveButton.addEventListener('click',(e:any)=> {
      if(w.hasClass(e.target, 'disabled')) {
        return;
      }
      if(!this.isSaving) {
        this.isSaving = true;
        if(saveButton) {
          saveButton.innerHTML = 'Please Wait...';
          saveButton.setAttribute('disabled', 'disabled');
          saveButton.classList.add('please-wait-state');
        }
        this.editMode ?
        w.Events.publish('startLoadingGrey'):
        w.Events.publish('startLoadingWhite');

        let input = <HTMLInputElement>document.getElementById('add-retailer-input'),
            data = {
              name: input.value,
              retailerId: parseInt(input.getAttribute('data-retailerId')) || null,
              locationId: parseInt(locationId),
              geom: this.addRetailerInfoWindow._position,
              skipSync: this.logoImageFile ? true : false
            },
            onAddSuccess = (response)=> {
              w.Events.publish('trackPropertyIds', response.propertyId);
              this.isSaving = false;
              if(saveButton) {
                saveButton.innerHTML = 'Save';
                saveButton.removeAttribute('disabled');
                saveButton.classList.remove('please-wait-state');
              }
              if(this.isLogoFileLoaded) {
                this.mapsAddStuffService.updateTenantLogo(response.retailerId, this.logoImageFile).subscribe((logoData: any)=>{
                  response.logoPinImage && (response.logoPinImage.url = logoData.logoMediaUrl);
                  w.apiRetailer.addNewRetailer(response);
                  this.makeRetailerPollingCall(response);
                  w.apiProperty.updatePropertyIfRetailerIsChanged(response);

                },(error)=>{
                  throw error;
                });
              } else {
                w.apiRetailer.addNewRetailer(response);
                this.makeRetailerPollingCall(response);
                w.apiProperty.updatePropertyIfRetailerIsChanged(response);
              }
              w.toggleRetailerFilter([response], true);
              w.Events.publish('endLoadingWhite');
              w.Events.publish('segment', {
                name: SegmentEvents.mapRetailerAdded,
                data: {
                  retailer_id: response.retailerId,
                  location_id: response.locationId,
                }
              });
              w.Events.publish('fetchRetailerFilterData');
              this.closeAddRetailerFlow();
            },
            onEditSuccess = (response)=> {
              
              w.Events.publish('trackPropertyIds', response.propertyId);
              this.isSaving = false;
              if(saveButton) {
                saveButton.innerHTML = 'Save';
                saveButton.removeAttribute('disabled');
                saveButton.classList.remove('please-wait-state');
              }
              
              w.apiProperty.updatePropertyIfRetailerIsChanged(response);
              var roofTopImageElement = <HTMLImageElement>document.getElementById('rooftop-pin-image');

              !(roofTopImageElement && roofTopImageElement.src === response.rooftopPinUrl) && w.apiRetailer.delete(retailerId, locationId);
              if(this.isLogoFileLoaded && response) {
                if(roofTopImageElement && roofTopImageElement.src === response.rooftopPinUrl) {
                  w.apiRetailer.delete(retailerId, locationId);
                  w.apiRetailer.addNewRetailer(response);
                  this.makeRetailerPollingCallForEdit(response);
                }
                  this.mapsAddStuffService.updateTenantLogo(response.retailerId, this.logoImageFile).subscribe((logoData: any)=>{
                  response.logoPinImage && (response.logoPinImage.url = logoData.logoMediaUrl);
                  this.addRetailerAfterEdit(response);
                },(error)=>{
                  throw error;
                });
              
              } else {
                w.apiRetailer.addNewRetailer(response);
                this.makeRetailerPollingCall(response);
              }
              w.toggleRetailerFilter([response], true);
              w.Events.publish('segment', {
                name: SegmentEvents.mapRetailerEdited,
                data: {
                  retailer_id: response.retailerId,
                  location_id: response.locationId,
                }
              });
              w.Events.publish('fetchRetailerFilterData');
              w.Events.publish('endLoadingGrey');
              this.closeAddRetailerFlow();
            },
            onError = (error)=> {
              this.isSaving = false;
              if(saveButton) {
                saveButton.innerHTML = 'Save';
                saveButton.removeAttribute('disabled');
                saveButton.classList.remove('please-wait-state');
              }
              this.editMode ?
              w.Events.publish('endLoadingGrey'):
              w.Events.publish('endLoadingWhite');

              if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
                let actionString = input.getAttribute('data-locationId')? 'edit-retailer': 'save-retailer';
                w.Events.publish('usageLimitErrorFeature', actionString);
                w.Events.publish('updateFeatureExecutionAfterSignUp', {
                  featureToExecute : actionString,
                  requestObject : data
                });
              }
              w.Events.publish('error', error);
            };
        if(this.editMode && (data.retailerId === this.currentRetailer.retailerId) && (data.name !== this.currentRetailer.name)) {
          data.retailerId = 0;
        }
        input.getAttribute('data-locationId') ? this.mapsAddStuffService.editRetailer(data).subscribe(onEditSuccess, onError)
                    : this.mapsAddStuffService.addRetailer(data).subscribe(onAddSuccess, onError);
      }
    });
  }

  addRetailerAfterEdit(retailer) {
    let w = (<any>window);
    this.mapsAddStuffService.getSingleRetailerDetail(retailer).subscribe((response)=>{
      w.apiRetailer.addNewRetailer(response);
      w.apiPolling.apiRetailerCall(retailer);
      w.apiPolling.replaceExistingRetailerImages(retailer)
    },(error)=>{
      throw error;
    });
  }

  makeRetailerPollingCallForEdit(retailer) {
    (<any>window).apiPolling.apiRetailerCall(retailer);
  }
  
  addRetailer(data?) {
    let w = (<any>window);
    w.contextualInfoWindow.closeAllInfoWindows();
    this.addRetailerInfoWindow = new w.SnazzyInfoWindow({
      content: this.getAddRetailerContentString(data || {}),
      position: this.addRetailerlatLng,
      map: w.map,
      placement: 'top',
      closeOnMapClick: false,
      wrapperClass: 'infowindow-add-retailer-overriding',
      pointer: '8px',
      showCloseButton: false,
      callbacks: {
        afterOpen: ()=>{
          this.addInputListener();
          this.fileUploadListener();
          this.cancelButtonListener();
          this.saveButtonListener(data && data.retailerId, data && data.locationId);
          if(w.userData.organizationType !== 'FREE') {
            w.addClass(document.getElementsByClassName('retailer-logo')[0], 'show-upload-retailer-logo');
            w.addClass(document.getElementsByClassName('retailer-logo')[0], 'retailer-image-hover');
          }
        }
      }
    });
    this.addRetailerInfoWindow.open();
  }

  fileUploadListener() {
    document.getElementById('tenant-logo-img-input').addEventListener('change', (e:any)=> {
      this.logoImageFile = e.target.files[0];
      let w = (<any>window),
      validImageSize = (this.logoImageFile.size < 5242880),
      validImageType =
      (this.logoImageFile.type.toLowerCase().indexOf('png') > -1) ||
      (this.logoImageFile.type.toLowerCase().indexOf('jpeg') > -1) ||
      (this.logoImageFile.type.toLowerCase().indexOf('svg') > -1);

      !validImageSize && w.Events.publish('notificationError', 'That file is too big, please keep your image upto 5MB');

      !validImageType && w.Events.publish('notificationError', 'That file type is not supported, please upload .svg, .jpg, or .png file');

      if(validImageType && validImageSize) {
        let reader = new FileReader();
        reader.onload = (event: any) => {
          this.toggleRetailerImage(true, event.target.result);
          this.isLogoFileLoaded = true;
          var retailerLogoElement = document.getElementsByClassName('retailer-logo')[0];
          var retailerLogoParentElement = retailerLogoElement.parentNode;
          var retailerLogoSiblingElement = retailerLogoElement.nextSibling;
          retailerLogoParentElement.removeChild(retailerLogoElement);
          setTimeout(function() {retailerLogoParentElement.insertBefore(retailerLogoElement, retailerLogoSiblingElement);}, 0)
        }
        reader.readAsDataURL(this.logoImageFile);
      }
      w.Events.publish('detectChanges');
    });
  }

  toggleSaveDisable(toggle) {
    let saveButtonElement = document.getElementById('btn-save-retailer');
    if(toggle) {
      (<any>window).addClass(saveButtonElement, 'disabled');
      saveButtonElement && saveButtonElement.setAttribute('disabled', 'disabled');
    } else {
      (<any>window).removeClass(saveButtonElement, 'disabled');
      saveButtonElement && saveButtonElement.removeAttribute('disabled');
    }
  }

  toggleRetailerImage(toggle, src) {
    let retailerImageElement = document.getElementById('retailer-image'),
    w = (<any>window);
    retailerImageElement.setAttribute('src', src);
    if(toggle) {
      retailerImageElement.classList.remove('hidden');
      retailerImageElement.classList.add('retailer-image-uploaded');
      this.toggleSaveDisable((<HTMLTextAreaElement>document.getElementById('add-retailer-input')).value.length === 0);
    } else {
      retailerImageElement.classList.add('hidden');
      retailerImageElement.classList.remove('retailer-image-uploaded');
      (<HTMLInputElement>document.getElementById('tenant-logo-img-input')).value = null;
    }
    w.Events.publish('detectChanges');
  }

  addInputListener() {
    let w = (<any>window), userInput,
        addRetailerInput = document.getElementById('add-retailer-input');

    if(addRetailerInput) {
      Observable.fromEvent(addRetailerInput, 'input')
        .debounceTime(500)
        .subscribe((e: any) => {
          userInput = (<HTMLTextAreaElement>e.target).value;
          if(userInput.length >= 1) {
            this.toggleSaveDisable(false);

            if(this.currentRetailer && this.currentRetailer.name !== userInput) {
              document.getElementById('add-retailer-input').removeAttribute('data-retailerId');
              this.toggleRetailerImage(false, '');
            }
            this.mapsAddStuffService.getRetailerWithName(userInput).subscribe((response)=>{
              this.showAutocomplete(response);
              this.searchPredictions = response;
              this.focusedSearchItemIndex = 0;
              this.addCustomRetailerClass(userInput);
            },
            (error)=>{
              if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
                w.Events.publish('usageLimitErrorFeature','save-retailer');
              }
              w.Events.publish('error', error);
            });
            w.Events.publish('detectChanges');
          } else {
            this.searchPredictions = [];
            this.toggleSaveDisable(true);
            this.addCustomRetailerClass(userInput);
            this.addRetailerAutocompleteInfoWindow && this.addRetailerAutocompleteInfoWindow.close();
          }
        });

      this.addRetailerInputListeners();

      addRetailerInput.addEventListener('blur', (e) => {
        setTimeout(() => {
          this.matchInputToRetailerSuggesstion((<HTMLTextAreaElement>e.target).value);
          this.addRetailerAutocompleteInfoWindow && this.addRetailerAutocompleteInfoWindow.close();
        }, 1000);
      });

      addRetailerInput.focus();
      w.Events.publish('detectChanges');
    }
  }

  matchInputToRetailerSuggesstion(userInput) {
    let selectedRetailer = document.getElementsByClassName('retailer-suggestion')[0];
    if(userInput && this.searchPredictions[0] && (userInput.toLowerCase() === this.searchPredictions[0].name.toLowerCase())) {
      selectedRetailer && this.autoCompleteExecute(selectedRetailer);
    } else {
      this.searchPredictions = [];
    }
    this.addCustomRetailerClass(userInput);
  }

  addCustomRetailerClass(userInput) {
    let retailerLogoElement = document.getElementsByClassName('retailer-logo'),
    retailerImageElement = document.getElementById('retailer-image'),
    addRetailerInfowindow = document.getElementById('add-retailer-infowindow'),
    w = (<any>window);
    userInput = this.mapsAddStuffService.trimSpacesBeforeAndAfterString(userInput);
    this.currentRetailer = { name: userInput ? userInput : null};
    if(!userInput && retailerImageElement) {
      this.toggleRetailerImage(false, '');
    }
    w.Events.publish('detectChanges');
  }

  showAutocomplete(response) {
    let w = (<any>window);
    if(response.length > 0) {
      if(this.addRetailerAutocompleteInfoWindow) {
        this.addRetailerAutocompleteInfoWindow.setContent(this.getAddRetailerAutocompleteContentString(response));
        setTimeout(()=>{
          this.addRetailerAutocompleteInfoWindow.isOpen() && this.addAutocompleteListner();;
        }, 0);
      } else {
        this.addRetailerAutocompleteInfoWindow = new w.SnazzyInfoWindow({
          content: this.getAddRetailerAutocompleteContentString(response),
          position: this.addRetailerlatLng,
          map: w.map,
          placement: 'top',
          closeOnMapClick: false,
          wrapperClass: 'infowindow-add-retailer-autocomplete-overriding',
          pointer: false,
          showCloseButton: false,
          offset: {
            top: '30px',
            left: '-34px'
          },
          callbacks: {
            afterOpen: ()=>{
              this.addAutocompleteListner();
            }
          }
        });
      }
      this.addRetailerAutocompleteInfoWindow.open();
    } else {
      this.addRetailerAutocompleteInfoWindow && this.addRetailerAutocompleteInfoWindow.close();
    }
  }

  getAddRetailerContentString(data) {
    let image = (data.logoPinImage && data.logoPinImage.url)? data.logoPinImage.url : ((data.rooftopPinImage && data.rooftopPinImage.url)? data.rooftopPinImage.url : null);
    return '<div class="infowindow-add-retailer" id="add-retailer-infowindow" onclick="base.stopProp(event);">'+
              '<label>Retailer Name</label><br />' +
              '<div class="input-container">' +
                '<input type="text" class="no-outline" maxlength="100" value="'+ (data.name ? data.name:'') +'" data-retailerId="' + data.retailerId + '" '+(data.locationId? 'data-locationId="' + data.locationId+'"' : '')  + '" onfocus="this.value = this.value;" id="add-retailer-input" autofocus />' +
              '</div>' +
              '<div class="button-container"><a class="btn btn-save disabled" id="btn-save-retailer">Save</a></div>' +
              '<div class="retailer-logo">' +
              '<img src="'+(image? image: '')+'" class="'+(image? 'retailer-image-uploaded': '')+'" id="retailer-image">' +
              '<input id="tenant-logo-img-input" class="tenant-logo-img-input hidden" type="file" >' +
              '<label for="tenant-logo-img-input" class="tenant-logo-label"><i class="material-icons upload-tenant-logo-icon">add_photo_alternate</i></label>' +
              '<span class="upload-tenant-logo-text"></span>' +
              '</div><a class="cancel" id="btn-cancel-retailer">Cancel</a></div>' +
           '</div>';
  }

  getAddRetailerAutocompleteContentString(response) {
      let html = '';
      response.forEach(function(retailer) {
        html += '<div class="retailer-suggestion" data-imageSrc="'+ ((retailer.logoPinImage && retailer.logoPinImage.url)?retailer.logoPinImage.url:((retailer.rooftopPinImage && retailer.rooftopPinImage.url)?retailer.rooftopPinImage.url:''))
                + '" data-retailerId="' + retailer.retailerId + '" data-retailerName="'+ retailer.name +'">' + retailer.name + '</div>';
      });
      return '<div id="infowindow-add-retailer-container" class="infowindow-add-retailer-autocomplete" onclick="base.stopProp(event);">'+ html + '</div>';
  }

  addRetailerInputListeners() {
    let searchInputElement = document.getElementById('add-retailer-input');
    if(searchInputElement) {
      searchInputElement.addEventListener('keyup', (event) => {
        let keyCode = event.keyCode;
        //Enter
        if(keyCode === 13) {
          let selectedRetailer = document.getElementsByClassName('retailer-suggestion')[this.focusedSearchItemIndex];
          this.autoCompleteExecute(selectedRetailer);
        }
        //Up arrow
        if(keyCode === 38) {
          this.goUpSearchPredictions();
        }
        //Down arrow
        if(keyCode === 40) {
          this.goDownSearchPredictions();
        }
      });
    }
  }

  autoCompleteExecute(searchItem?) {
    let retailerId = ((searchItem && searchItem.target) ? searchItem.target : searchItem).getAttribute('data-retailerId'),
        retailerName = ((searchItem && searchItem.target) ? searchItem.target : searchItem).getAttribute('data-retailerName'),
        retailerImage = ((searchItem && searchItem.target) ? searchItem.target : searchItem).getAttribute('data-imageSrc'),
        innerHtml = ((searchItem && searchItem.target) ? searchItem.target : searchItem).innerText,
        input = document.getElementById('add-retailer-input'),
        img = document.getElementById('retailer-image');
    this.currentRetailer = {retailerId : parseInt(retailerId), name : retailerName};
    (<HTMLInputElement>input).value = innerHtml;
    input.setAttribute('data-retailerId', retailerId);
    this.toggleRetailerImage(true, retailerImage);
    this.addRetailerAutocompleteInfoWindow.close();
    (<any>window).Events.publish('detectChanges');
  }

  goUpSearchPredictions() {
    if(this.focusedSearchItemIndex === 0) {
      this.focusedSearchItemIndex = this.searchPredictions.length - 1;
      let retailerInfowindow = document.getElementById('infowindow-add-retailer-container');
      retailerInfowindow.parentElement.scrollTop = retailerInfowindow.parentElement.scrollHeight;
    } else {
      this.focusedSearchItemIndex--;
      if(this.focusedSearchItemIndex > 1) {
        document.getElementById('infowindow-add-retailer-container').parentElement.scrollTop -= 28;
      }
    }
    let searchItems = document.getElementsByClassName('retailer-suggestion');
    (<HTMLElement>searchItems[this.focusedSearchItemIndex ===  this.searchPredictions.length - 1? 0 : this.focusedSearchItemIndex + 1]).classList.remove('focused');
    this.changeFocusedSearchItemBackgroundColor(searchItems);
  }

  goDownSearchPredictions() {
    if(this.focusedSearchItemIndex === this.searchPredictions.length - 1) {
      this.focusedSearchItemIndex = 0;
      document.getElementById('infowindow-add-retailer-container').parentElement.scrollTop = 0;
    } else {
      this.focusedSearchItemIndex++;
      if(this.focusedSearchItemIndex > 3) {
        document.getElementById('infowindow-add-retailer-container').parentElement.scrollTop += 28;
      }
    }
    let searchItems = document.getElementsByClassName('retailer-suggestion');
    (<HTMLElement>searchItems[this.focusedSearchItemIndex ===  0 ? this.searchPredictions.length - 1 : this.focusedSearchItemIndex - 1]).classList.remove('focused');
    this.changeFocusedSearchItemBackgroundColor(searchItems);
  }

  changeFocusedSearchItemBackgroundColor(searchItems) {
    (<HTMLElement>searchItems[this.focusedSearchItemIndex]).classList.add('focused');
  }

  addAutocompleteListner() {
    let retailerEls = document.getElementsByClassName('retailer-suggestion');
    this.changeFocusedSearchItemBackgroundColor(retailerEls);

    for(let i=0; i < retailerEls.length; i++) {
      retailerEls[i].addEventListener('click', (e:any) => {
        this.autoCompleteExecute(e);
      });
    }
  }

  makeRetailerPollingCall(retailer) {
    if(!(retailer.dotPinImage && retailer.dotPinImage.url && retailer.rooftopPinImage && retailer.rooftopPinImage.url && retailer.smallPinImage && retailer.smallPinImage.url)) {
      (<any>window).apiPolling.apiRetailerCall(retailer);
    }
  }

  removeSubscriptions() {
    this.addRetailerFlowSubscription && this.addRetailerFlowSubscription.unsubscribe();
    this.closeAddRetailerFlowSubscription && this.closeAddRetailerFlowSubscription.unsubscribe();
    this.editRetailerSubscription && this.editRetailerSubscription.unsubscribe();
    this.moveRetailerSubscription && this.moveRetailerSubscription.unsubscribe();
    this.removeRetailerSubscription && this.removeRetailerSubscription.unsubscribe();
    this.alterRetailerCapsulePublicSubscription && this.alterRetailerCapsulePublicSubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.removeSubscriptions();
    this.closeAddRetailerFlow();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-add-stuff/components/add-retailer/add-retailer.component.ts